// removed by extract-text-webpack-plugin
module.exports = {"container":"_25N0l"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-page-footer-wrapper/post-page-footer-wrapper.scss
// module id = 1724
// module chunks = 0